import * as React from 'react';
import { FlexRow, FlexCol } from '../Flexbox/Flexbox';
import styled from 'styled-components';
import { relative } from 'path';

export interface Props {
  children: any;
  mobile?: boolean;
  position?: string;
  className?: string;
}

export class Nav extends React.Component<Props, {}> {
  render() {
    const { children } = this.props;
    return (
      <React.Fragment>
        {this.props.mobile ? (
          <MobileNavComponent className={this.props.className}>
            {children}
          </MobileNavComponent>
        ) : (
          <NavComponent position={this.props.position}>{children}</NavComponent>
        )}
      </React.Fragment>
    );
  }
}

const NavComponent: any = styled(FlexRow)`
  position: ${(props: any) => props.position || 'relative'};
  flex-wrap: wrap;
`;

const MobileNavComponent = styled(FlexCol)`
  width: 100%;
`;
